module.exports = __webpack_public_path__ + "img/Taurus.0e1b5ce0.png";